
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import BillingService from "services/billing-service";

function PaymentSuccess() {
  const navigate = useNavigate();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [validSuccess, setValidSuccess] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionIdFromUrl = params.get("session_id");

    let attempts = 0;
    const maxAttempts = 10; // 10 attempts * 1s = 10 seconds timeout
    const checkBillingStatus = async () => {
      try {
        const billingResponse = await BillingService.getLatestBillingRecord();
        const billing = billingResponse.billing;

        console.log(`🧾 Checking billing [Attempt ${attempts + 1}/${maxAttempts}]:`, billing?.status);

        // 1. Check Success Status
        if (billing && billing.status === "Success" && billing.display_result === true) {
          setValidSuccess(true);
          setShowSnackbar(true);

          await BillingService.updateBillingRecord(billing.session_id, { display_result: false });
          console.log("✅ Billing record updated to hide result next time.");
        }
        // 2. If Initial/Pending, Retry
        else if (billing && billing.status === "Initial" && attempts < maxAttempts) {
          console.log("⏳ Billing is still Initial. Retrying...");
          attempts++;
          setTimeout(checkBillingStatus, 1000); // Poll every 1 second
        }
        // 3. Failure or Timeout
        else {
          console.warn("⚠️ Billing record invalid, failed, or already shown. Redirecting...");
          // Only redirect if we are sure (timeout or explicit failure)
          if (billing.status === "Fail") {
            navigate("/payment/fail");
          } else {
            navigate("/profile");
          }
        }
      } catch (err) {
        console.error("❌ Error checking billing:", err.message);
        // If error, maybe retry a few times?
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkBillingStatus, 1000);
        } else {
          navigate("/profile");
        }
      }
    };

    checkBillingStatus();
  }, [navigate]);

  if (!validSuccess) return null;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <Card
          sx={{
            p: 4,
            maxWidth: 460,
            width: "90%",
            borderRadius: "16px",
            textAlign: "center",
            backgroundColor: "rgba(255,255,255,0.95)", // Glass-ish
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          }}
        >
          <MDTypography variant="h1" sx={{ mb: 1, fontSize: "4rem !important" }}>
            🎉
          </MDTypography>

          <MDTypography variant="h4" fontWeight="bold" gutterBottom color="dark">
            Subscription Successful!
          </MDTypography>

          <MDTypography variant="body2" color="text" sx={{ mb: 3 }}>
            Thank you! Your subscription is now active.
          </MDTypography>

          <MDButton
            variant="contained"
            color="accent"
            size="large"
            onClick={() => navigate("/profile")}
            sx={{ px: 4, py: 1.5, fontWeight: 600, width: "100%" }}
          >
            Go to Profile
          </MDButton>
        </Card>
      </MDBox>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setShowSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Your subscription was processed successfully.
        </Alert>
      </Snackbar>
      <Footer />
    </DashboardLayout>
  );
}

export default PaymentSuccess;
